
import { Component } from "@angular/core";
@Component({
    selector: 'shop-faq',
  templateUrl: 'faq-component.html',
  styleUrls: ['faq-component.scss']
})

export class FaqComponent {
  princepipes:boolean = false;

  ngOnInit(){
    const webshop = JSON.parse(sessionStorage.getItem('webshopDetail'));
    if(webshop && webshop.DomainName === "princepipes"){
        this.princepipes = true;
    }

  }
}